import React, { useState, useEffect } from "react";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";

import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import { useSnackbar } from "notistack";
import TextField from '@material-ui/core/TextField';
import axios from 'axios';
import CircularProgress from '@material-ui/core/CircularProgress';
import LockIcon from '@material-ui/icons/Lock';

//import '../stripe.css';

const styles = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
        width: 50
    },
});

const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            {true ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

let snackbarkey = null;

export default function CheckoutForm(props) {
    const [succeeded, setSucceeded] = useState(false);
    const [error, setError] = useState(null);
    const [processing, setProcessing] = useState('');
    const [disabled, setDisabled] = useState(true);
    //const [clientSecret, setClientSecret] = useState('');
    const stripe = useStripe();
    const elements = useElements();

    const nameRef = React.useRef();
    const messageRef = React.useRef();

    const handleClose = () => {
        props.setOpen(false);
    };

    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    useEffect(() => {

        closeSnackbar(snackbarkey);

        if (error !== null && error !== '') {
            snackbarkey = enqueueSnackbar(error, {
                variant: 'error',
                persist: true,
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'center',
                }
            });
        }

    }, [error]);

    const cardStyle = {
        style: {
            base: {
                color: "#32325d",
                fontFamily: 'Arial, sans-serif',
                fontSmoothing: "antialiased",
                fontSize: "16px",
                "::placeholder": {
                    color: "#32325d"
                }
            },
            invalid: {
                color: "#fa755a",
                iconColor: "#fa755a"
            }
        }
    };

    const handleChange = async (event) => {
        // Listen for changes in the CardElement
        // and display any errors as the customer types their card details
        setDisabled(event.empty);
        setError(event.error ? event.error.message : "");
    };

    const handleSubmit = async ev => {
        ev.preventDefault();

        if (error) return;
        setProcessing(true);

        let clientSecret = props.clientSecret;

        //create subscription
        if (!props.onceOff) {
            let response;

            try {
                response = await axios.post('/api/payment/makeSub', { amount: props.amount, message: messageRef.current.value }, { withCredentials: true });
            }
            catch (error) {
                enqueueSnackbar(`${error.response.data.error.message}`, { variant: 'error', });
                setProcessing(false);
                return;
            }
            clientSecret = response.data.clientSecret;
        } else {
            await axios.post('/api/payment/makeOnceOff', { amount: props.amount, message: messageRef.current.value });
        }

        const stripeDetails = {
            payment_method: {
                card: elements.getElement(CardElement),
            }
        }

        //only add name if we have it
        if (nameRef.current && nameRef.current.value) {
            stripeDetails.payment_method.billing_details = { name: nameRef.current.value };
            console.log('name was present' + nameRef.current.value);
        }

        const payload = await stripe.confirmCardPayment(clientSecret, stripeDetails);

        if (payload.error) {
            setError(`Payment failed ${payload.error.message}`);
            setProcessing(false);
        } else {
            setError(null);
            setProcessing(false);
            setSucceeded(true);
            //enqueueSnackbar(`Payment completed successfully. Thanks!`, { variant: 'success' });
            props.setOpen(false);
            props.setSuccess(true);
        }
    };

    return (
        <Dialog
            open={props.open}
            onClose={handleClose}
            aria-labelledby="form-dialog-title"
            maxWidth="xs"
            fullWidth
        >
            {/* <DialogTitle id="customized-dialog-title"
                onClose={handleClose}
            >Confirm Details</DialogTitle> */}
            <DialogContent>
                <div>
                    <Typography variant="h6" style={{ fontWeight: 400, textAlign: 'center' }}>{props.onceOff ? 'Once off donation for' : 'Monthy donation for'}</Typography>
                    <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'center', padding: '20px' }}>
                        <Typography variant="h4" style={{ fontWeight: 300 }}>$</Typography>
                        <Typography variant="h2" style={{ marginLeft: '5px', lineHeight: 0.9 }}>{props.amount}</Typography>
                        <Typography variant="body1" style={{ textAlign: 'center', marginLeft: '10px' }}>USD</Typography>
                    </div>

                    {!props.onceOff && <Typography
                        variant="body1"
                        style={{ fontWeight: 400, textAlign: 'center', marginBottom: '20px' }}>
                        You'll get our goal {props.goal} {props.percentage}% closer to completion!
                    </Typography>}

                    {/* {!props.authed && <Typography
                        variant="body1"
                        style={{ fontWeight: 400, textAlign: 'center', marginBottom: '20px' }}>
                        Warning: You won't get access to exclusive models unless you log in!!
                    </Typography>} */}
                    {!props.authed && <TextField style={{ width: '100%', marginBottom: '15px' }} label="Your name (optional)" inputRef={nameRef} variant="outlined" />}
                    <TextField style={{ width: '100%', marginBottom: '15px' }} label="Message (optional)" variant="outlined" inputRef={messageRef} multiline rowsMax={5} />

                </div>
                <form style={{ width: '100%' }} onSubmit={handleSubmit}>
                    <CardElement id="card-element" options={cardStyle} onChange={handleChange} />
                    <Button
                        disabled={processing || disabled || succeeded}
                        id="submit"
                        variant="contained"
                        style={{ width: '100%' }}
                        color="primary"
                        onClick={handleSubmit}
                        children={
                            <span id="button-text">
                                {processing ? <CircularProgress size={30} /> : "Contribute"}
                            </span>
                        }
                    >
                    </Button>
                </form>
                <Typography variant="body2" color="textSecondary" style={{ textAlign: 'center', marginTop: '20px' }}>
                    <LockIcon size="small" style={{ fontSize: '12px', marginRight: '3px' }} />Powered by Stripe
                </Typography>
            </DialogContent>
        </Dialog>
    );
}
